import { createSelector } from "reselect";

import Store, { RootState } from "../../../redux/store";
import { ProductHistoryState } from "../types/product-history.interface";
import { BasicResourceType } from "../../../types/resources/resources.enums";

import * as actions from "./product-history.actions";

export const getProductHistoryState = (state: RootState) => state.productHistory;

export const getErrors = createSelector(
  getProductHistoryState,
  (state: ProductHistoryState) => state.errors
);

export const getHistory = createSelector(
  getProductHistoryState,
  (state: ProductHistoryState) => state.history?.results ?? []
);

export const getNext = createSelector(
  getProductHistoryState,
  (state: ProductHistoryState) => state.history?.next ?? ""
);

export const hasErrors = createSelector(
  getProductHistoryState,
  (state: ProductHistoryState) => !!state.errors
);

export const isLoading = createSelector(
  getProductHistoryState,
  (state: ProductHistoryState) => state.loading
);

export function clear() {
  Store.dispatch(actions.clear());
}

export function fetchHistory(resourceType: BasicResourceType, resourceId: number) {
  Store.dispatch(actions.fetch(resourceType, resourceId));
}

export function nextHistory(endpoint: string) {
  Store.dispatch(actions.next(endpoint));
}
